(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-announcement"] && !Shopify.designMode) return;
  try {
    
  class NvCountdown extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.end;
      const parsed = raw ? new Date(raw).getTime() : NaN;
      this.h = this.querySelector('[data-h]');
      if (!this.h) return;
      this.m = this.querySelector('[data-m]');
      this.s = this.querySelector('[data-s]');
      this.end = Number.isNaN(parsed) ? null : parsed;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const now = new Date();
      let end = this.end;
      if (!end || end <= now.getTime()) {
        const d = new Date(now);
        d.setHours(24, 0, 0, 0);
        end = d.getTime();
      }
      const left = Math.max(0, Math.floor((end - now.getTime()) / 1000));
      const pad = (n) => String(n).padStart(2, '0');
      this.h.textContent = pad(Math.floor(left / 3600));
      this.m.textContent = pad(Math.floor((left % 3600) / 60));
      this.s.textContent = pad(left % 60);
    }
  }
  if (!customElements.get('nv-countdown')) customElements.define('nv-countdown', NvCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-marquee"] && !Shopify.designMode) return;
  try {
    
  class NvTicker extends HTMLElement {
    connectedCallback() {
      this.vp = this.querySelector('.nv-ticker__viewport');
      this.speed = parseFloat(this.dataset.speed) || 40;
      this.pos = 0;
      this.hold = false;
      this.drag = null;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.vp.addEventListener('pointerdown', (e) => this.down(e));
      this.vp.addEventListener('pointermove', (e) => this.move(e));
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((n) => this.vp.addEventListener(n, () => this.up()));
      this.vp.addEventListener('touchstart', () => this.hold = true, { passive: true });
      this.vp.addEventListener('touchend', () => this.release(), { passive: true });
      this.addEventListener('mouseenter', () => this.hold = true);
      this.addEventListener('mouseleave', () => this.release());
      this.addEventListener('focusin', () => this.hold = true);
      this.addEventListener('focusout', () => this.release());
      this.vp.addEventListener('scroll', () => this.wrap(), { passive: true });
      this.last = performance.now();
      if (!this.reduced) this.raf = requestAnimationFrame((t) => this.tick(t));
    }
    disconnectedCallback() { cancelAnimationFrame(this.raf); clearTimeout(this.timer); }
    get half() { return this.vp.scrollWidth / 2; }
    wrap() {
      const h = this.half;
      if (!h) return;
      if (this.vp.scrollLeft >= h) this.vp.scrollLeft -= h;
      else if (this.vp.scrollLeft <= 0) this.vp.scrollLeft += h;
      this.pos = this.vp.scrollLeft;
    }
    release() { clearTimeout(this.timer); this.timer = setTimeout(() => { this.hold = false; }, 1200); }
    down(e) {
      if (e.pointerType === 'touch') return;
      this.hold = true;
      this.drag = { x: e.clientX, left: this.vp.scrollLeft };
      this.vp.setPointerCapture(e.pointerId);
      this.vp.classList.add('is-dragging');
    }
    move(e) {
      if (!this.drag) return;
      this.vp.scrollLeft = this.drag.left - (e.clientX - this.drag.x);
    }
    up() {
      if (!this.drag) return;
      this.drag = null;
      this.vp.classList.remove('is-dragging');
      this.release();
    }
    tick(t) {
      const dt = Math.min(64, t - this.last);
      this.last = t;
      if (!this.hold && !document.hidden) {
        this.pos += (this.speed * dt) / 1000;
        this.vp.scrollLeft = this.pos;
        this.wrap();
      } else {
        this.pos = this.vp.scrollLeft;
      }
      this.raf = requestAnimationFrame((n) => this.tick(n));
    }
  }
  if (!customElements.get('nv-ticker')) customElements.define('nv-ticker', NvTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-product-hero"] && !Shopify.designMode) return;
  try {
    
  class NvGallery extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('nv-slider');
      this.track = this.querySelector('.nv-slider__track');
      this.thumbs = [...this.querySelectorAll('[data-nv-thumb]')];
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.slider.goTo(i)));
      this.track.addEventListener('scroll', () => this.sync(), { passive: true });
      this.sync();
    }
    sync() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      this.thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      const strip = this.querySelector('.nv-gallery__thumbs');
      const active = this.thumbs[i];
      if (strip && active) strip.scrollTo({ left: active.parentElement.offsetLeft - (strip.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
    }
  }
  if (!customElements.get('nv-gallery')) customElements.define('nv-gallery', NvGallery);

  (() => {
    let done = false;
    const fill = () => {
      if (done) return;
      done = true;
      document.querySelectorAll('.nv-gallery img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    };
    const gallery = document.querySelector('.nv-gallery');
    if (gallery) ['pointerdown', 'touchstart', 'keydown', 'focusin', 'mouseover'].forEach((ev) => gallery.addEventListener(ev, fill, { once: true, passive: true }));
    const later = () => setTimeout(fill, 1200);
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  })();

  class NvAtc extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.btn = this.querySelector('.nv-atc__btn');
      this.err = this.querySelector('.nv-form__error');
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.submit(e));
      this.form.querySelector('select[name="id"]')?.addEventListener('change', (e) => {
        const opt = e.target.selectedOptions[0];
        this.querySelectorAll('[data-nv-cta-price]').forEach((el) => (el.textContent = opt.dataset.price));
        const root = this.closest('.nv-hero__info') || document;
        const pr = root.querySelector('[data-nv-price]'), cp = root.querySelector('[data-nv-compare]');
        if (pr) pr.textContent = opt.dataset.full;
        if (cp) { cp.textContent = opt.dataset.was || ''; cp.hidden = !opt.dataset.was; }
      });
    }
    async submit(e) {
      e.preventDefault();
      if (this.busy || this.btn.disabled) return;
      this.busy = true;
      this.btn.classList.add('is-loading');
      this.err.hidden = true;
      const cart = document.querySelector('cart-drawer');
      const useDrawer = this.dataset.after === 'drawer' && cart && typeof cart.renderContents === 'function';
      const body = new FormData(this.form);
      if (useDrawer) {
        body.append('sections', cart.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart.');
        if (useDrawer) {
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
          cart.renderContents(data);
          this.btn.classList.remove('is-loading');
          this.busy = false;
          return;
        }
        window.location.href = this.dataset.after === 'checkout' ? '/checkout' : '/cart';
      } catch (err) {
        this.err.textContent = err.message;
        this.err.hidden = false;
        this.btn.classList.remove('is-loading');
        this.busy = false;
      }
    }
  }
  if (!customElements.get('nv-atc')) customElements.define('nv-atc', NvAtc);

  (() => {
    const fmt = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    const run = () => document.querySelectorAll('.nv-delivery[data-days]').forEach((box) => {
      const slot = box.querySelector('[data-nv-date]');
      if (!slot) return;
      let left = parseInt(box.dataset.days, 10) || 0;
      const d = new Date();
      while (left > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) left--; }
      slot.textContent = fmt(d);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  (() => {
    const parse = (t) => { const m = String(t || '').replace(/\s/g, '').match(/[\d.,]+/); if (!m) return NaN; let n = m[0]; const c = n.lastIndexOf(','), d = n.lastIndexOf('.'); if (c > d) n = n.replace(/\./g, '').replace(',', '.'); else n = n.replace(/,/g, ''); return parseFloat(n); };
    const setup = (box) => {
      const now = box.querySelector('[data-nv-price]'), was = box.querySelector('[data-nv-compare]'), save = box.querySelector('[data-nv-save]');
      const root = box.closest('.nv-hero__info') || document;
      const base = { now: now && now.textContent, was: was && was.textContent, wasHidden: was ? was.hidden : true };
      const pct = () => {
        if (!save) return;
        const a = parse(now && now.textContent), b = parse(was && !was.hidden ? was.textContent : '');
        if (b > a && a > 0) { save.textContent = (box.dataset.saveText || 'Save [percent]%').replace('[percent]', Math.round((1 - a / b) * 100)); save.hidden = false; } else save.hidden = true;
      };
      const offer = () => {
        if (box.dataset.offer !== 'true') return false;
        const e = box.dataset.selNow && document.querySelector(box.dataset.selNow);
        if (!e || !e.textContent.trim()) return false;
        now.textContent = e.textContent.trim();
        const w = box.dataset.selWas && document.querySelector(box.dataset.selWas);
        if (was) { if (w && w.textContent.trim()) { was.textContent = w.textContent.trim(); was.hidden = false; } else was.hidden = true; }
        pct();
        return true;
      };
      const sync = () => { if (!offer()) { if (now) now.textContent = base.now; if (was) { was.textContent = base.was; was.hidden = base.wasHidden; } pct(); } };
      root.addEventListener('change', (e) => {
        const o = e.target.matches && e.target.matches('select[name="id"]') ? e.target.selectedOptions[0] : null;
        if (o) { base.now = o.dataset.full; base.was = o.dataset.was; base.wasHidden = !o.dataset.was; sync(); }
      });
      const watch = () => root.querySelectorAll('.nv-app-offer').forEach((el) => { if (el._nvw) return; el._nvw = true; new MutationObserver(() => requestAnimationFrame(sync)).observe(el, { subtree: true, childList: true, attributes: true, characterData: true }); el.addEventListener('click', () => setTimeout(sync, 60)); el.addEventListener('change', () => setTimeout(sync, 60)); });
      watch(); sync();
      let n = 0; const t = setInterval(() => { watch(); sync(); if (++n > 20) clearInterval(t); }, 500);
    };
    const run = () => document.querySelectorAll('[data-nv-price-block]').forEach(setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  class NvStickyCta extends HTMLElement {
    connectedCallback() {
      const target = document.querySelector(this.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(([entry]) => {
        const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.hidden = !past;
      });
      this.observer.observe(target);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  if (!customElements.get('nv-sticky-cta')) customElements.define('nv-sticky-cta', NvStickyCta);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const stopAll = (except) => {
      document.querySelectorAll('.nv-video__frame').forEach((f) => {
        if (f === except) return;
        const p = f.querySelector('.nv-video__player');
        if (p && !p.hidden) {
          p.querySelector('video')?.pause();
          p.hidden = true;
          const b = f.querySelector('[data-nv-play]');
          if (b) b.hidden = false;
        }
      });
    };
    document.addEventListener('click', (e) => {
      const play = e.target.closest('[data-nv-play]');
      const expand = e.target.closest('[data-nv-expand]');
      const close = e.target.closest('[data-nv-close]');
      if (play) {
        const frame = play.closest('.nv-video__frame');
        stopAll(frame);
        const player = frame.querySelector('.nv-video__player');
        player.hidden = false;
        play.hidden = true;
        player.querySelector('video')?.play();
      } else if (expand) {
        const frame = expand.closest('.nv-video__frame');
        stopAll();
        const dlg = frame.querySelector('.nv-video__dialog');
        dlg.showModal();
        dlg.querySelector('video')?.play();
      } else if (close) {
        close.closest('dialog').close();
      } else if (e.target.matches && e.target.matches('.nv-video__dialog')) {
        e.target.close();
      }
    });
    document.addEventListener('close', (e) => {
      if (e.target.matches && e.target.matches('.nv-video__dialog')) e.target.querySelector('video')?.pause();
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
